import ModalChat, { type MessageProps } from './ModalChat';

export { MessageProps };
export default ModalChat;
